var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAllowed('createImportFile'))?_c('v-btn',{attrs:{"small":_vm.$vuetify.breakpoint.smAndUp,"x-small":_vm.$vuetify.breakpoint.xsOnly,"to":{ name: 'ImportFile', params: { importFile: _vm.importData}}}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":_vm.$vuetify.breakpoint.xsOnly}},[_vm._v("mdi-file-import")]),_vm._v(" Import ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }